export default [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "vnd.ms-excel",
    "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "vnd.openxmlformats-officedocument.wordprocessingml.document",
    "msword",
    "pdf"
];